import * as React from 'react';
export const IcCallCancel = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.65 6.77l1.06-1.06A.996.996 0 1018.3 4.3l-1.06 1.06-1.06-1.06a.996.996 0 10-1.41 1.41l1.06 1.06-1.06 1.06a.996.996 0 101.41 1.41l1.06-1.06 1.06 1.06a.996.996 0 101.41-1.41l-1.06-1.06zm-.48 7.55c-.78-.78-2.05-.78-2.83 0l-.71.71c-.71.71-1.41 0-1.41 0l-4.24-4.24c-.71-.71 0-1.41 0-1.41l.71-.71c.78-.78.78-2.05 0-2.83l-.71-.71c-.78-.78-2.05-.78-2.83 0l-.99.99c-.31.31-.51.7-.57 1.14-.17 1.41-.06 4.74 3.68 8.48s7.08 3.85 8.48 3.68c.43-.05.83-.26 1.14-.57l.99-.99c.78-.78.78-2.05 0-2.83l-.71-.71z'
      fill='currentColor'
    />
  </svg>
);
